module.exports = __webpack_public_path__ + "img/pet2.174c8543.jpg";